import type { IconProps } from './../../models/icon';

export function LoanIcon({
  width = 24,
  height = 24,
  secondaryColor = 'var(--color-200)',
  className = '',
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={className}
    >
      <g clipPath="url(#a)">
        <path
          fill="#fff"
          d="M5.04619 22.3479L0.856934 18.857V12.8569H5.43677C6.34609 12.8569 7.21815 13.2182 7.86115 13.8611L9.85693 15.8569C10.567 16.567 10.567 17.7183 9.85693 18.4284C9.65878 18.6266 9.42627 18.7694 9.17857 18.857H16.8569C18.4349 18.857 19.7141 20.1362 19.7141 21.714C19.7141 22.5031 19.0745 23.1427 18.2856 23.1427H7.24111C6.43904 23.1427 5.66235 22.8614 5.04619 22.3479Z"
        />
        <path
          fill={secondaryColor}
          d="M19.3244 0.956449C19.2243 0.896467 19.1108 0.862351 18.9942 0.857178H14.4342C14.3176 0.862351 14.2042 0.896467 14.1041 0.956449C14.004 1.01643 13.9204 1.10039 13.8609 1.20074C13.8014 1.3011 13.7677 1.41471 13.7631 1.5313C13.7584 1.6479 13.7829 1.76381 13.8342 1.86861L15.1028 3.58289C11.8971 5.14289 10.2856 7.20004 10.2856 10.3715C10.2856 13.2515 12.9599 14.5715 16.7142 14.5715C20.4685 14.5715 23.1428 13.2515 23.1428 10.3715C23.1428 7.20004 21.5314 5.14289 18.3256 3.58289L19.5942 1.86861C19.6456 1.76381 19.67 1.6479 19.6654 1.5313C19.6607 1.41471 19.6271 1.3011 19.5675 1.20074C19.508 1.10039 19.4245 1.01643 19.3244 0.956449Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M19.3244 0.956449C19.2243 0.896467 19.1108 0.862351 18.9942 0.857178H14.4342C14.3176 0.862351 14.2042 0.896467 14.1041 0.956449C14.004 1.01643 13.9204 1.10039 13.8609 1.20074C13.8014 1.3011 13.7677 1.41471 13.7631 1.5313C13.7584 1.6479 13.7829 1.76381 13.8342 1.86861L15.1028 3.58289C11.8971 5.14289 10.2856 7.20004 10.2856 10.3715C10.2856 13.2515 12.9599 14.5715 16.7142 14.5715C20.4685 14.5715 23.1428 13.2515 23.1428 10.3715C23.1428 7.20004 21.5314 5.14289 18.3256 3.58289L19.5942 1.86861C19.6456 1.76381 19.67 1.6479 19.6654 1.5313C19.6607 1.41471 19.6271 1.3011 19.5675 1.20074C19.508 1.10039 19.4245 1.01643 19.3244 0.956449Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M0.856934 18.8569L5.04619 22.3479C5.66235 22.8613 6.43904 23.1426 7.24111 23.1426H18.2856C19.0745 23.1426 19.7141 22.503 19.7141 21.714C19.7141 20.1361 18.4349 18.8569 16.8569 18.8569H9.17857"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M5.99979 17.1426L7.28551 18.4284C7.99558 19.1385 9.14686 19.1385 9.85693 18.4284C10.567 17.7183 10.567 16.567 9.85693 15.8569L7.86115 13.8611C7.21815 13.2182 6.34609 12.8569 5.43677 12.8569H0.856934"
        />
      </g>
    </svg>
  );
}
